<template>
    <div class="label">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'Label',
}
</script>

<style lang='scss' scoped>
.label {
    color: rgba(131, 131, 131, 1);
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 5px;
    cursor: default;
    user-select: none;
}
</style>